import { Dialog } from '@st/theme'

import { Modal } from '@st/theme'

import { Folder } from '@st/sdk'
import { Button, DialogButtons } from '@st/theme'
import { formatPercentage } from '@st/util/format'
import { useState } from 'react'
import { match } from '@st/pattern'
import { ClientCard, ClientCardStepHeading } from './ui'

export function ClientQuestionnaireCard({
  stepNumber,
  folder,
  onClickEnterQuestionnaire,
  isLocked,
  documentUploadsEnabled
}: {
  stepNumber: number
  folder: Folder
  onClickEnterQuestionnaire: () => void
  isLocked?: boolean
  documentUploadsEnabled: boolean
}) {
  const [dialog, setDialog] = useState<'locked' | undefined>(undefined)
  const progress = formatPercentage(folder.clientOrganizer.questionnaireProgress)
  const completed = folder.clientOrganizer.questionnaireCompleted
  const completedAction = match(completed)
    .with(true, () => ({ label: 'View', variant: 'default' as const }))
    .otherwise(() => ({ label: 'Enter Questionnaire', variant: 'primary' as const }))
  const statusClassName = match(completed)
    .with(true, () => 'text-green-600')
    .otherwise(() => 'text-orange-600')

  return (
    <ClientCard>
      <div>
        <ClientCardStepHeading
          stepNumber={stepNumber}
          completed={completed}
          title={<h2 className="text-xl font-semibold text-gray-900">Complete Questionnaire</h2>}
          status={<span className={statusClassName}>{progress}% complete</span>}
          action={
            <Button
              variant={completedAction.variant}
              size="l"
              className={isLocked ? 'min-w-24 opacity-80' : 'min-w-24'}
              onClick={() => {
                if (isLocked) {
                  setDialog('locked')
                } else {
                  onClickEnterQuestionnaire()
                }
              }}
            >
              {completedAction.label}
            </Button>
          }
        />

        {match(dialog)
          .with('locked', () => {
            return (
              <Modal isOpen={true}>
                <Dialog
                  title="Questionnaire locked"
                  subtitle={match(documentUploadsEnabled)
                    .with(
                      true,
                      () =>
                        'A questionnaire cannot be edited once it has been submitted, but you can upload additional documents above at any time. Please contact us if you have any questions.'
                    )
                    .with(
                      false,
                      () =>
                        'A questionnaire cannot be edited once it has been submitted. Please contact us if you have any questions.'
                    )
                    .exhaustive()}
                  buttons={
                    <DialogButtons>
                      <Button variant="primary" onClick={() => setDialog(undefined)}>
                        OK
                      </Button>
                    </DialogButtons>
                  }
                />
              </Modal>
            )
          })
          .otherwise(() => null)}
      </div>
    </ClientCard>
  )
}
